import React from "react"

export const SmallLoader = () => {
  return <div className="loader"/>
}
export const MediumLoader = () => {
  return <div className="loader"/>
}
